export default "__VITE_ASSET__DeUiM6Wf__"